// extracted by mini-css-extract-plugin
export var cartIcon = "_ji-0";
export var cartIconContainer = "_ji-1";